import { FloatLabel } from "primereact/floatlabel";
import { InputTextarea } from "primereact/inputtextarea";
import styles from "../index.module.css";
import React from "react";

interface ParamProps {
  fieldName: string;
  label: string;
  currentObject: any;
  isDisable?: boolean;
  isInvalid?: boolean;
  getValue: string | undefined;
  setValue: (updatedObject: any) => void;
  maxLength?: number;
  resize?: boolean;
}

const MobileInputTextAreaComponent: React.FC<ParamProps> = (params: ParamProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    const updatedObject = {
      ...params.currentObject,
      [params.fieldName]: newValue,
    };
    params.setValue(updatedObject);
  };

  const currentLength = params.getValue?.length || 0;

  return (
    <div className="w-full">
        <InputTextarea
            id={params.fieldName}
            rows={5}
            autoResize={params.resize ? false : true}
            className={`w-full ${params.resize ? "resize-none" : ""}`}
            placeholder={params.label}
            value={params?.getValue}
            disabled={params.isDisable || false}
            invalid={params.isInvalid || false}
            maxLength={params.maxLength}
            onChange={handleChange}
        />
        
      {params.maxLength && (
        <div className="text-right text-sm text-gray-500 mt-1">
          {currentLength}/{params.maxLength}
        </div>
      )}
    </div>
  );
};

export default MobileInputTextAreaComponent;
